import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { fmtDate } from './gedUtils';

const API = process.env.REACT_APP_BACKEND_URL;

export const ReportEcheancesDialog = ({ r, headers, onClose, onDone }) => {
  const restantes = r.echeances.filter((e) => e.statut !== 'paye');
  const [mode, setMode] = useState('date');
  const [dateVal, setDateVal] = useState((restantes[0]?.date_echeance || '').slice(0, 10));
  const [jours, setJours] = useState(30);
  const [busy, setBusy] = useState(false);
  const valider = async () => {
    setBusy(true);
    try {
      const body = mode === 'date' ? { mode, date_echeance: dateVal } : { mode, jours: Number(jours) };
      const res = await axios.post(`${API}/api/paiements-cb/admin/${r.source}/${r.id}/echeances/report`, body, { headers });
      toast.success(`${res.data.nb_echeances} échéance(s) décalée(s) de ${Math.abs(res.data.decalage_jours)} jour(s) — le membre a reçu son nouvel échéancier`);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || 'Report impossible'); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="report-dialog">
        <DialogHeader>
          <DialogTitle>Reporter les échéances restantes</DialogTitle>
          <DialogDescription>{r.nom} · {r.reference} — {restantes.length} échéance(s) non payée(s), prochaine le {fmtDate(restantes[0]?.date_echeance)}.</DialogDescription>
        </DialogHeader>
        <RadioGroup value={mode} onValueChange={setMode} className="space-y-3">
          <label className="flex items-start gap-3 cursor-pointer">
            <RadioGroupItem value="date" data-testid="report-mode-date" className="mt-1" />
            <span className="flex-1 space-y-1">
              <span className="block text-sm font-medium">Nouvelle date de la prochaine échéance</span>
              <span className="block text-xs text-slate-500">Les suivantes conservent leur espacement actuel.</span>
              <Input type="date" value={dateVal} min={new Date().toISOString().slice(0, 10)} disabled={mode !== 'date'} onChange={(e) => setDateVal(e.target.value)} className="h-8 w-44" data-testid="report-date-input" />
            </span>
          </label>
          <label className="flex items-start gap-3 cursor-pointer">
            <RadioGroupItem value="jours" data-testid="report-mode-jours" className="mt-1" />
            <span className="flex-1 space-y-1">
              <span className="block text-sm font-medium">Décaler toutes les échéances restantes de</span>
              <span className="flex items-center gap-2 text-sm">
                <Input type="number" min={1} max={365} value={jours} disabled={mode !== 'jours'} onChange={(e) => setJours(e.target.value)} className="h-8 w-24" data-testid="report-jours-input" /> jour(s)
              </span>
            </span>
          </label>
        </RadioGroup>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="report-cancel-btn">Annuler</Button>
          <Button onClick={valider} disabled={busy} className="bg-[#0a3d62] hover:bg-[#0c4a75]" data-testid="report-submit-btn">
            {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />} Reporter et prévenir le membre
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
